import React from 'react';
import { Button } from 'dw-us-ui';
import styled from '@emotion/styled';
import { useHistory } from 'react-router-dom';
import RichText from '../../../util/RichText';
import { EmotionBreakpoint } from 'dw-us-ui';

const ButtonWithContentCardContainer = styled.div`
  ${EmotionBreakpoint('notDesktop')} {
    .button-card-title {
      padding: 2.5rem 1rem 1.5rem;
    }
  }
  ${EmotionBreakpoint('notDesktop')} {
    button {
      font-size: 12px;
      padding: 0 10px;
    }
  }
  height: 100%;
  .button-card-title {
    padding: 2.5rem 1.5rem 1.5rem;
    font-size: 1.2rem;
    line-height: 2rem;
    ${EmotionBreakpoint('mobile')} {
      padding: 2.5rem 1rem 1.5rem;
    }
  }
  .button-card-content {
    padding: 0 2rem;
  }
  .button-card-btn {
    display: flex;
    justify-content: center;
    margin-top: 1.6rem;
    padding-bottom: 25px;
  }
`;

const ButtonWithContentCard = ({ fields }) => {
  const history = useHistory();
  let buttonDetails = {};

  const getValue = blocks => {
    blocks.map(ele => {
      switch (ele?.sys?.contentType?.sys?.id) {
        case 'link':
          buttonDetails['text'] = ele.fields.text;
          buttonDetails['url'] = ele.fields.url;
          break;

        case 'textBlockWithMobile': {
          buttonDetails['title'] = ele.fields.title;
          buttonDetails['content'] = ele?.fields?.content ? RichText(ele.fields.content) : null;
          break;
        }
        default: {
          return null;
        }
      }
    });
  };
  getValue(fields?.blocks);

  return (
    <ButtonWithContentCardContainer data-testid="button-card" className="button-card d-flex flex-column h-100">
      {buttonDetails?.title && (
        <div className="mx-0 px-lg-5 px-lg-5 flex-fill button-card-title">
          <h2 data-testid="content-title" className="text-center card-title-wrap">
            <strong>{buttonDetails?.title}</strong>
          </h2>
        </div>
      )}
      {buttonDetails?.content && (
        <div className="mx-0 px-lg-5 px-lg-5 flex-fill">
          <div data-testid="content-text" className="text-center button-card-content">
            {buttonDetails?.content}
          </div>
        </div>
      )}
      <div className="mx-0 justify-content-center flex-fill button-card-btn">
        <div className="d-flex justify-content-center">
          <Button
            buttonType="primary"
            buttonSize="small"
            onClick={() => {
              window.location.href = buttonDetails?.url;
            }}
          >
            {buttonDetails?.text}
          </Button>
        </div>
      </div>
    </ButtonWithContentCardContainer>
  );
};

export { ButtonWithContentCard };
